import VueCookies from "vue-cookies";

export default {
    isKey(key) {
        var value = false;
        if (navigator.userAgent.match(
            /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        ) != null && typeof cordova != "undefined") {
            // 手機
            var storage = window.localStorage;
            if (storage.getItem(key)) {
                value = true;
            } else {
                value = false;
            }
        } else {
            // 網頁
            value = $cookies.isKey(key);
        }
        return value;
    },
    get(key) {
        var value = "";
        if (navigator.userAgent.match(
            /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        ) != null && typeof cordova != "undefined") {
            // 手機
            var storage = window.localStorage;
            value = storage.getItem(key);
        } else {
            // 網頁
            value = $cookies.get(key);
        }
        return value;
    },
    set(key, value) {
        if (navigator.userAgent.match(
            /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        ) != null && typeof cordova != "undefined") {
            // 手機
            var storage = window.localStorage;
            storage.setItem(key, value)
        } else {
            // 網頁
            $cookies.set(key, value, "1y", "/", location.hostname, "", "Lax");
        }
        return true;
    },
    set(key, value, time) {
        if (navigator.userAgent.match(
            /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        ) != null && typeof cordova != "undefined") {
            // 手機
            var storage = window.localStorage;
            storage.setItem(key, value)
        } else {
            // 網頁
            $cookies.set(key, value, time, "/", location.hostname, "", "Lax");
        }
        return true;
    },
    remove(key) {
        if (navigator.userAgent.match(
            /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        ) != null && typeof cordova != "undefined") {
            // 手機
            var storage = window.localStorage;
            storage.removeItem(key)
        } else {
            // 網頁
            $cookies.remove(key, "/", location.hostname);
        }
        return true;
    }
}


// WEBPACK FOOTER //
// ./src/utils/storage.js